import React, { useEffect, useState } from 'react'
import './styles.scss'
import { Sparkline } from 'components/sparkline'
import { formatSwissDate } from 'components/globalDrawFunctions'

import csvjson from 'csvjson'
import DataWrapperChart from 'components/DataWrapperChart'
import { MultiLine } from 'components/ChartTools/Charts_MultiLine/component'
import { addDays } from 'components/ChartTools/Charts_Assets'
import { AreaAndLine } from 'components/ChartTools/Charts_AreaAndLine'
import { Kantonstabelle } from 'components/Kantonstabelle'
import { isMobile } from 'components/globalConfig'

const changeArrows: { [key: string]: string } = {
  right:
    'M31.0672,1.1723l15.5877,15.5877c.4393,.4421,.4393,1.156,0,1.5981l-15.588,15.588c-1.5451,1.5451-4.0503,1.5451-5.5955,0s-1.5451-4.0503,0-5.5955l6.8348-6.8348-28.3646,.0004C1.7562,21.5077-.0085,19.7292,0,17.5438c.0085-2.1733,1.7682-3.933,3.9415-3.9415l28.3678-.0044-6.8348-6.8348c-1.5516-1.5364-1.564-4.0397-.0276-5.5913,1.5364-1.5516,4.0397-1.564,5.5913-.0276l.0282,.0282h.0007Z',
  down:
    'M43.4224,13.67V35.7144a1.1336,1.1336,0,0,1-1.13,1.13H20.2476a3.9566,3.9566,0,1,1,0-7.9132h9.6658L7.735,6.7534a3.957,3.957,0,0,1,5.596-5.596L35.5145,23.3346V13.6689a3.9537,3.9537,0,1,1,7.9073.0008Z',
  up:
    'M20.2477,0H42.292a1.1336,1.1336,0,0,1,1.13,1.13V23.1748a3.9566,3.9566,0,0,1-7.9132,0V13.509L13.331,35.6874a3.957,3.957,0,0,1-5.596-5.596L29.9123,7.9079H20.2465A3.9537,3.9537,0,1,1,20.2473.0006Z'
}

const startForSparklines = new Date(2021, 9, 1)
const today = new Date(new Date().setHours(0))
const oneDay = 24 * 60 * 60 * 1000
const diffDays = Math.round(Math.abs((+today - +startForSparklines) / oneDay))
const daysBackFromNow = diffDays || 60

const firstofmonth = (date: string | Date) => {
  const month = new Date(date).getMonth()
  const day = 2
  const year = new Date(date).getFullYear()
  return new Date(year, month, day)
}

interface Props {
  isMobile: boolean
}
type factDataType = {
  dates: { start: string; end: string }
  new: { cases: number; death: number; hosp: number; capacity: number }
  total: { cases: number; death: number }
  ave7: { cases: number; death: number }
  changeNew: { cases: string; death: string; hosp: string; capacity: string }
  changeAve7: { cases: string; death: string; hosp: string }
  allAve7Cases: number[]
  allAve7Death: number[]
  allDailyCases: number[]
  allDailyDeath: number[]
  allRValues: number[]
  lastR: string
  lastRDate: string
  lastRSpan: string
}

type factDataType_2 = {
  allAve7Cases_: number[]
  allAve7Death_: number[]
  allDailyCases_: number[]
  allDailyDeath_: number[]
  caseTestRatio: { d: string; v: number }
}
type rDataType = {
  date: string
  median_R_highHPD: string
  median_R_lowHPD: string
  median_R_mean: string
  region: string
}
const Segment = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'ui vertical ' + additionalClasses + ' segment'}>
    {children && children}
  </div>
)
const Loader = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <Segment>
    <div className={'ui active inverted dimmer ' + additionalClasses}>
      <div className='ui text loader'>{children}</div>
    </div>
  </Segment>
)
//
export const Facts = ({ isMobile }: Props) => {
  const [factData, setFactData] = useState<factDataType | undefined>(undefined)
  const [factData3, setFactData3] = useState<any>(undefined)
  const [factData2, setFactData2] = useState<factDataType_2 | undefined>(
    undefined
  )
  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/summary_v5.json?a=' +
        Math.random()
    )
      .then(response => response.json())
      .then((data: factDataType) => {
        setFactData3(data)
      })
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/dashboard-facts.json?a=' +
        Math.random()
    )
      .then(response => response.json())
      .then((data: factDataType) => {
        setFactData(data)
        fetch(
          'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/dashboard-facts_2.json?a=' +
            Math.random()
        )
          .then(response => response.json())
          .then((data: factDataType_2) => {
            setFactData2(data)
          })
      })
    // })
  }, [])

  if (!factData)
    return (
      <div className='factContainer'>
        <Loader>Lade Übersicht...</Loader>
      </div>
    )

  const formatDate = (datestring: string) => {
    const weekdays = [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag'
    ]
    const d = new Date(datestring)
    const weekday = d.getDay()
    const day = d.getDate()
    const month = d.getMonth() + 1
    const year = d.getFullYear()
    return day + '.' + month + '.' + year
  }

  const nf = new Intl.NumberFormat('de-CH')
  const num = (a: number) => (a > 9999 ? nf.format(a) : a)

  const dates = [
    new Date(factData.dates.start).toLocaleDateString('de-CH', {
      day: 'numeric',
      month: 'long'
      // year: 'numeric'
    }),
    new Date(factData.dates.end).toLocaleDateString('de-CH', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }),
    new Date(factData.dates.end).toLocaleDateString('de-CH', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  ]

  const newInfections = factData.new.cases
  const newDeaths = factData.new.death
  const newHosps = factData.new.hosp
  const newCapacity = factData.new.capacity
  const totalDeaths = factData.total.death
  const totalInfections = factData.total.cases

  const ave7Infections = factData.ave7.cases
  const ave7Deaths = factData.ave7.death
  const ave7Hosp = factData.ave7.hosp

  const charts = {
    height: 200,
    xTicks: {
      text: [
        firstofmonth('2020-03-10')
          .toISOString()
          .split('T')[0],
        firstofmonth(new Date())
          .toISOString()
          .split('T')[0]
      ],
      lines: [
        firstofmonth(new Date())
          .toISOString()
          .split('T')[0]
      ]
    }
  }
  return (
    <div className='factContainer'>
      {factData && factData3 && (
        <>
          <div className='titlewrapper'>
            <div className='title'>
              Situation in der Schweiz
              <br />
              am <span>{dates[2]}</span>
            </div>
            <div className='disclaimer'>
              Daten stammen vom BAG nach Meldedatum. <br />
              Das BAG publiziert jeweils am <br />
              <b>Dienstag um 15:30 Uhr</b> neue Zahlen.
            </div>
          </div>
          <div className='flexrow norm'>
            <div className='sub first'>
              Woche vom{' '}
              <span>
                <b>{dates[0]}</b> bis <b>{dates[1]}</b>
              </span>
            </div>
            <ValueElement
              label='Bestätigte Fälle'
              value={factData3.cases_change.last_week}
              type='cases'
              change={factData3.cases_change.percent_increase}
              changeLabel={isMobile ? 'z. Vorwoche' : 'Zur Vorwoche'}
              ave7={+(factData3.cases_change.last_week / 7).toFixed(1)}
            />
            <ValueElement
              label='Todesfälle'
              value={factData3.deaths.last_week}
              type='death'
              change={factData3.deaths.percent_increase}
              changeLabel={isMobile ? 'z. Vorwoche' : 'Zur Vorwoche'}
              ave7={+(factData3.deaths.last_week / 7).toFixed(1)}
            />
            {/* }
            <ValueElement
              label='Spitaleintritte'
              value={factData3.hosp_change.last_week}
              type='hosp'
              change={factData3.hosp_change.percent_increase + ''}
              changeLabel={isMobile ? 'z. Vorwoche' : 'Zur Vorwoche'}
              ave7={+(factData3.hosp_change.last_week / 7).toFixed(1)}
            />
            <ValueElement
              label='Spitalbelegung'
              value={factData3.hosp_capacity.last_day}
              type='capacity'
              change={factData3.hosp_capacity.percent_increase + ''}
            />
            */}
          </div>
          <div className='flexrow charts  '>
            <div className='c wide'>
              <div className='title'>
                Testpositivitätsrate
                <span>PCR- und Antigen-Tests, wöchentlich</span>
              </div>
              {factData2 && (
                <MultiLine
                  data={[factData2.caseTestRatio.filter(f => f.v)]}
                  yDomain={[70, 0]}
                  yTicks={{
                    lines: [0, 35, 70],
                    text: [35, 70]
                  }}
                  xDomain={[
                    new Date('2020-03-01'),
                    new Date(addDays(isMobile ? 120 : 50, new Date()))
                  ]}
                  className='pandemic tests'
                  interactive={!isMobile}
                  unit='%'
                  {...charts}
                />
              )}
            </div>
          </div>{' '}
          <div className='flexrow charts '>
            <div className='c'>
              <div className='title'>
                Bestätigte Fälle
                <span>Durchschnitt der letzten 7 Tage</span>
              </div>
              {factData2 && (
                <AreaAndLine
                  data={[factData2.allDailyCases_, factData2.allAve7Cases_]}
                  yDomain={[50000, 0]}
                  yTicks={{
                    lines: [0, 25000, 50000],
                    text: [25000, 50000]
                  }}
                  xDomain={[
                    new Date('2020-03-01'),
                    new Date(addDays(110, new Date()))
                  ]}
                  interactive={!isMobile}
                  {...charts}
                  className='pandemic cases'
                />
              )}
            </div>
            <div className='c'>
              <div className='title'>
                Todesfälle <span>Durchschnitt der letzten 7 Tage</span>
              </div>
              {!factData2 && (
                <div className='factContainer'>
                  <Loader>Lade Charts...</Loader>
                </div>
              )}
              {factData2 && (
                <AreaAndLine
                  data={[factData2.allDailyDeath_, factData2.allAve7Death_]}
                  yDomain={[120, 0]}
                  yTicks={{
                    lines: [0, 60, 120],
                    text: [60, 120]
                  }}
                  xDomain={[
                    new Date('2020-03-01'),
                    new Date(addDays(110, new Date()))
                  ]}
                  interactive={!isMobile}
                  {...charts}
                  className='pandemic death'
                />
              )}
            </div>
          </div>
          <div className='relaxed flexrow norm '>
            <ValueElement
              label='Total'
              value={num(totalInfections) as number}
              type='cases'
            />
            <ValueElement
              label='Total'
              value={num(totalDeaths) as number}
              type='death'
            />
          </div>
          {/* <Kantonstabelle /> */}
        </>
      )}
    </div>
  )
}
export default Facts

const Change = ({ changestring }: { changestring: string }) => {
  let arrowdirection = 'right'
  let color = '#776f57'
  switch (changestring.charAt(0)) {
    case '+':
      arrowdirection = 'up'
      color = '#d3343f'
      break
    case '-':
      arrowdirection = 'down'
      color = '#378ebd'
      break
  }
  return (
    <>
      {changestring}
      <i className={`arrow ${arrowdirection} icon`} style={{ color }} />
    </>
  )
}
const ValueElement = ({
  label = 'Label',
  value = 12345,
  type = 'cases',
  change,
  changeLabel,
  ave7
}: {
  label: string
  value: number
  type: 'cases' | 'death' | 'hosp' | 'capacity'
  change?: number | undefined
  changeLabel?: string
  ave7?: number
}) => {
  let arrowdirection = 'right'
  let color = '#9698A8'
  let change_str = null // if value for previous week was 0, increase percentage is inf%
  if (change) {
    change_str = change > 0 ? '+' + change : '' + change
    switch (change_str.charAt(0)) {
      case '0':
        arrowdirection = 'right'
        color = '#d3343f'
        break

      case '-':
        arrowdirection = 'down'
        color = '#202346'
        break
      default:
        arrowdirection = 'up'
        color = '#d3343f'
        break
    }
  }

  return (
    <div
      className={'ValueElement' + (change || changeLabel ? '' : ' noChange')}
    >
      <div
        className={'label' + (!change && !ave7 && !changeLabel ? ' fw' : '')}
      >
        {label}
        {(change || ave7 || changeLabel) && <div className='spacer' />}
      </div>
      <div className={'value ' + (type && type)}>
        <div className={'val ' + (type && type)}> {value}</div>
      </div>
      {(change || changeLabel) && (
        <>
          <div className={`changeindicator ${type && type}`}>
            <div className='arrowwrapper' style={{ opacity: change ? 1 : 0 }}>
              <div className='arrow'>
                <svg viewBox='0 -4 50 50'>
                  <path d={changeArrows[arrowdirection]} />
                </svg>
              </div>
              <span className='changevalue'>{change}%</span>
            </div>
          </div>
        </>
      )}
      {(ave7 || ave7 === 0) && (
        <div className='changelabel'>
          <span className='avelabel'>
            {isMobile ? '7-Tage-Ø' : '7-Tage-Schnitt'}
          </span>{' '}
          <span className={'avevalue ' + (type && type)}>
            {ave7.toLocaleString('ch-DE')}
          </span>
        </div>
      )}
    </div>
  )
}
